import React, { Component } from 'react';
import InputMaterial from '../UI/InputMaterial/InputMaterial';
import SearchSelectMenu from '../UI/SearchSelectMenu/SearchSelectMenu';

class FrequentFlyerDetails extends Component {

    state = {
        ffnData: null
    }

    componentWillMount() {
        let ffnData = null;
        ffnData = this.props.data[0].map(item => {
            let data = {};
            data.value = item.ac;
            data.label = item.an;
            return data;
        })
        this.setState({ ffnData });
    }

    render() {
        return (
            <div className="u-flex phone-f-column">
                <div className={`u-flex align-items-center mr-4 u-relative u-height60`} style={{flex: '0 0 16rem'}}>
                    <SearchSelectMenu 
                        value={this.props.selectedOption}
                        options={this.state.ffnData} 
                        onChange={this.props.onHandleChange} 
                        placeholder='Select' />
                </div>
                <div className={`u-flex align-items-center mr-4`}>
                    <InputMaterial 
                        type='text'
                        label='Frequent Flyer No' 
                        alignment='left' 
                        onChange={this.props.inputHandler} 
                        value={this.props.frequentFlyerNumber}
                        name='frequentFlyerNumber'/>
                </div>
            </div>
        );
    }
} 


export default FrequentFlyerDetails;


// WEBPACK FOOTER //
// ./src/components/FrequentFlyerDetails/FrequentFlyerDetails.js